import React from 'react';
import {LocationFavoriteSearchViewVO} from "../../../types/model/valueObject/location/LocationFavoriteSearchViewVO";
import {BuyerLocationFavoriteCardListItem} from "./BuyerLocationFavoriteCardListItem";
import {withLoader} from "../../hocs/withLoader";
import {LocationCardSkeleton} from "../../common/reports/loadingSkeletons/LocationCardSkeleton";

type BuyerLocationFavoriteCardListProps = {
  items?: LocationFavoriteSearchViewVO[];
}

const BuyerLocationFavoriteCardList = ({ items }: BuyerLocationFavoriteCardListProps) => {
  if (!items?.length) {
    return;
  }

  return <>
    {
      items.map((item, _index) =>
        <BuyerLocationFavoriteCardListItem
          key={item.locationId}
          item={item}
      />)
    }
  </>
}

const skeletonLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <LocationCardSkeleton key={index} />
));

const BuyerLocationFavoriteCardListWithLoader = withLoader(BuyerLocationFavoriteCardList, skeletonLoader);

export {
  BuyerLocationFavoriteCardList,
  BuyerLocationFavoriteCardListWithLoader
};
